import React from 'react';

export const PastEventEmptyQuestionnaire: React.FC = () => {
  return (
    <div className="tw-flex tw-flex-col tw-items-center tw-justify-center tw-rounded-3xl tw-border tw-border-dashed tw-border-border-grey tw-bg-background-grey tw-py-[42px]">
      <p className="tw-m-0 tw-text-sm tw-leading-5">
        Questions can’t be added for a past event.{' '}
        <a
          href="https://help.epochapp.com/articles/how-do-i-create-a-questionnaire"
          target="_blank"
          rel="noopener noreferrer"
          className="tw-text-primary hover:tw-underline"
        >
          Learn more
        </a>
      </p>
    </div>
  );
};
